import { JsonObject } from '../../helpers';
import { ConnectorFeatureSet, ConnectorUser } from '.';
import { ConnectorModel } from './connector.model';
import TailscaleLogo from '@/assets/connector-icons/tailscale.png';

export type TailscaleConfig = {
  xAuthenticatedUserEnabled: boolean;
  tailnetId: string;
  user: ConnectorUser | undefined;
  userId: string;
};

export class TailscaleConnectorModel extends ConnectorModel {
  config: TailscaleConfig;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof ConnectorModel, unknown>;

    this.type = 'tailscale';
    this.typeLabel = 'Tailscale';
    this.iconSVG = TailscaleLogo;

    this.supportedFeatures = (data.supportedFeatures as ConnectorFeatureSet) || {
      siem: false,
      privateModels: false,
      contextData: false,
      ingress: true,
    };

    this.config = (data.config as TailscaleConfig) || {
      xAuthenticatedUserEnabled: false,
      tailnetId: '',
      user: undefined,
      userId: '',
    };

    this.highlander = true;

    this.demo = true;
  }
}
